import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'assessmentDecisionReviewer';

const initialState = {
    data: []
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
    }
})

export const { setData } = slice.actions;
export const { reducer } = slice;

export const selectData = state => json.fromJSON(state[name].data);

const assessmentDecisionReviewerReducer = reducer;
export default assessmentDecisionReviewerReducer;